import type { ReactNode } from "react";
import { EditTeamModalProvider } from "./TeamAdministration/EditTeamModalContext";

interface PlanningProvidersProps {
  children: ReactNode;
}

export function PlanningProviders({ children }: PlanningProvidersProps) {
  return <EditTeamModalProvider>{children}</EditTeamModalProvider>;
}
